import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import throttle from 'lodash/throttle';

/**
 * Hook that returns the viewport size and listens for changes.
 */
export function useViewportSize() {
  var _React$useState = React.useState(function () {
      return readViewportSize();
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    viewport = _React$useState2[0],
    setViewport = _React$useState2[1];
  var updateViewport = React.useCallback(function () {
    return setViewport(readViewportSize());
  }, []);
  React.useEffect(function () {
    var handler = throttle(updateViewport, 400);
    window.addEventListener('resize', handler);
    return function () {
      window.removeEventListener('resize', handler);
    };
  }, [updateViewport]);
  return viewport;
}
function readViewportSize() {
  var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return {
    width: width,
    height: height
  };
}
//# sourceMappingURL=viewport-hooks.js.map
